namespace nscs.gameplay {

    export class Factory {
        private static ANIM:object = {
            'chickette_small': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'squat':{'start': 18, 'end':18},
                'pounceLand':{'start': 19, 'end':35},
                'pounce':{'start': 36, 'end':66},
                'climbing':{'start': 67, 'end':83},
                'grow':{'start': 84, 'end':115}
            },
            'chickette_big': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':49},
                'climbing':{'start': 50, 'end':66},
                'grow':{'start': 67, 'end':98},
                'seaKittenise':{'start': 99, 'end':133}
            },
            'nugget_small': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':59},
                'climbing':{'start': 60, 'end':76},
                'grow':{'start': 77, 'end':108}
            },
            'nugget_big': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':49},
                'climbing':{'start': 50, 'end':66},
                'grow':{'start': 67, 'end':98},
                'seaKittenise':{'start': 99, 'end':133}
            },
            'pam_small': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':64},
                'climbing':{'start': 65, 'end':81},
                'grow':{'start': 82, 'end':113}
            },
            'pam_big': {
                'walk':{'start': 0, 'end':17},
                'idle':{'start': 0, 'end':5},
                'fly':{'start': 6, 'end':6},
                'pounceLand':{'start': 18, 'end':34},
                'pounce':{'start': 35, 'end':49},
                'climbing':{'start': 50, 'end':66},
                'grow':{'start': 67, 'end':98},
                'seaKittenise':{'start': 99, 'end':133}
            }
        };

        scene:Phaser.Scene;
        constructor(scene:Phaser.Scene) {
            this.scene = scene;
            this.createAnimations();
        }

        private createAnimations():void {
            for (let k in Factory.ANIM) {
                let textureAtlas:string = 'objects-atlas';

                let data = Factory.ANIM[k];
                for (let animKey in data) {
                    let anim:string = Factory.createAnimName(animKey, k);
                    if (!this.scene.anims.exists(anim)) {
                        let animData = data[animKey];
                        let frames;
                        let genFrm = (_data)=>{
                            return this.scene.anims.generateFrameNames(textureAtlas, {
                                start: _data['start'], end: _data['end'], zeroPad: 4,
                                prefix: k, suffix: ''
                            });
                        };
                        if (animData.hasOwnProperty("length")) {
                            frames = [];
                            for (let ad of animData) {
                                let _frames = genFrm(ad);
                                frames = frames.concat(_frames);
                            }
                        } else {
                            frames = genFrm(animData);
                        }
                        this.scene.anims.create({
                            key: anim,
                            frames: frames,
                            frameRate: 60
                        });
                    }
                }
            }
        }

        public static createAnimName(animKey:string, frameName:string):string {
            return animKey + "_" + frameName;
        }

        private createDecorSprite(libId:string):Phaser.GameObjects.Sprite {
            let mapOrigins:object = {
                'decor112MC':{'x':16/841, 'y':6/130},
                'decor113MC':{'x':59/151, 'y':12/155},
                'decor92MC':{'x':0/148, 'y':3/233},
                'decor91MC':{'x':0, 'y':0},
                'decor77MC':{'x':29/144, 'y':3/147},
                'decor82MC':{'x':48/96, 'y':-15/96},
                'decor4MC':{'x':0, 'y':0},
                'decor100MC':{'x':17/135, 'y':250/329},
                'decor109MC':{'x':74/148, 'y':47/80},
                'decor101MC':{'x':87/178, 'y':-21/91},
                'decor115MC':{'x':0, 'y':0},
                'decor108MC':{'x':75/150, 'y':47/80},
                'decor84MC':{'x':51/102, 'y':-25/22},
                'decor83MC':{'x':50/102, 'y':-15/23},
                'decor79MC':{'x':31/96, 'y':0/111},
                'decor81MC':{'x':21/22, 'y':3/115},
                'decor78MC':{'x':31/160, 'y':3/117},
                'decor64MC':{'x':0, 'y':0},
                'decor63MC':{'x':0, 'y':0},
                'decor65MC':{'x':0, 'y':0},
                'decor62MC':{'x':0, 'y':0},
                'decor73MC':{'x':0, 'y':0},
                'decor10MC':{'x':0.5, 'y':1},
                'decor26MC':{'x':0.5, 'y':1},
                'decor86MC':{'x':0, 'y':0},
                'decor98MC':{'x':62/126, 'y':39/68},
                'decor99MC':{'x':82/126, 'y':39/68},
                'decor97MC':{'x':38/57, 'y':0.6},
                'decor95MC':{'x':54/111, 'y':35/112},
                'decor94MC':{'x':54/111, 'y':35/112},
                'decor93MC':{'x':54/111, 'y':35/112},
                'decor80MC':{'x':31/23, 'y':3/113},
                'decor76MC':{'x':51/147, 'y':3/146},
                'decor12MC':{'x':0/96, 'y':5/69},
                'decor69MC':{'x':25/307, 'y':0/135},
                'decor15MC':{'x':0, 'y':0},
                'decor16MC':{'x':0.12, 'y':0.77},
                'decor68MC':{'x':-5/58, 'y':1/79},
                'decor19MC':{'x':0, 'y':0},
                'decor13MC':{'x':0, 'y':0},
                'decor17MC':{'x':0, 'y':0},
                'decor18MC':{'x':0, 'y':0},
                'decor14MC':{'x':0, 'y':0},
                'decor20MC':{'x':0, 'y':0},
                'decor107MC':{'x':77/154, 'y':47/80},
                'decor106MC':{'x':80/160, 'y':47/82},
                'decor105MC':{'x':74/148, 'y':47/81},
                'decor104MC':{'x':71/142, 'y':47/81},
                'decor103MC':{'x':75/150, 'y':47/81},
                'decor102MC':{'x':75/150, 'y':47/81},
                'decor71MC':{'x':23/78, 'y':28/76},
                'decor70MC':{'x':23/78, 'y':15/76},
                'decor72MC':{'x':0, 'y':0},
                'decor67MC':{'x':0, 'y':0},
                'decor74MC':{'x':8/56, 'y':1/37},
                'decor75MC':{'x':8/56, 'y':1/37},
                'decor110MC':{'x':22/47, 'y':0/21},
                'decor31MC':{'x':22/45, 'y':21/21},
                'decor37MC':{'x':0.5, 'y':1},
                'decor66MC':{'x':0, 'y':0},
                'decor96MC':{'x':45/57, 'y':1},
                'decor7MC':{'x':0, 'y':0},
                'decor36MC':{'x':0.5, 'y':1},
                'decor61MC':{'x':16/96, 'y':32/64},
                'decor59MC':{'x':0.5, 'y':1},
                'decor114MC':{'x':0, 'y':0},
                'decor6MC':{'x':0, 'y':0},
                'decor8MC':{'x':0, 'y':0},
                'decor111MC':{'x':0, 'y':0},
                'decor90MC':{'x':0, 'y':0},
                'decor89MC':{'x':0, 'y':0},
                'decor88MC':{'x':0, 'y':0},
                'decor87MC':{'x':0, 'y':0},
            };
            let animations:object = {
                'decor95MC':{'start': 0, 'end':93, 'autoplay':true},
                'decor94MC':{'start': 0, 'end':93, 'autoplay':true},
                'decor93MC':{'start': 0, 'end':93, 'autoplay':true},
                'decor37MC':{'start': 0, 'end':82, 'autoplay':true},
                'decor36MC':{'start': 0, 'end':82, 'autoplay':true},
                'decor71MC':{'start': 0, 'end':29, 'autoplay':true},
                'decor70MC':{'start': 0, 'end':29, 'autoplay':true},
                'decor110MC':{'start': 0, 'end':21, 'autoplay':false},
                'decor31MC':{'start': 0, 'end':21, 'autoplay':false},
                'decor99MC':{'start': 0, 'end':73, 'autoplay':true},
                'decor98MC':{'start': 0, 'end':53, 'autoplay':true},
                'decor96MC':{'start': 0, 'end':59, 'autoplay':true},
                'decor97MC':{'start': 0, 'end':73, 'autoplay':true},
                'decor26MC':{'start': 0, 'end':89, 'autoplay':true},
                'decor10MC':{'start': 0, 'end':89, 'autoplay':true},
            };
            let bodySize:object = {
                'decor95MC':{x:0, y:55, yFlipped:6, w:110, h:46},
                'decor94MC':{x:0, y:55, yFlipped:6, w:110, h:46},
                'decor93MC':{x:0, y:55, yFlipped:6, w:110, h:46},
                'decor71MC':{x:12, y:-17, w:59, h:56},
                'decor70MC':{x:12, y:41, w:59, h:56},
                'decor110MC':{x:0, y:0, w:44, h:10},
                'decor31MC':{x:0, y:11, w:44, h:12},
                'decor37MC':{x:-18, y:-36, w:36, h:36},
                'decor107MC':{x:0, y:31, w:154, h:78},
                'decor109MC':{x:0, y:31, w:154, h:78},
                'decor104MC':{x:0, y:31, w:142, h:78},
                'decor105MC':{x:0, y:31, w:148, h:78},
                'decor106MC':{x:0, y:31, w:160, h:78},
                'decor103MC':{x:0, y:31, w:150, h:78},
                'decor102MC':{x:0, y:31, w:150, h:78},
                'decor108MC':{x:0, y:31, w:150, h:78},
                'decor99MC':{x:30, y:10, w:57, h:37},
                'decor97MC':{x:35, y:20, w:57, h:37},
                'decor98MC':{x:20, y:10, w:57, h:37},
                'decor12MC':{x:28, y:0, w:36, h:64},
                'decor15MC':{x:0, y:3, w:96, h:64},
                'decor16MC':{x:45, y:246, w:38, h:62},
                'decor17MC':{x:28, y:6, w:38, h:64},
                'decor18MC':{x:-10, y:45, w:96, h:38},
                'decor14MC':{x:-9, y:45, w:96, h:38},
                'decor13MC':{x:11, y:45, w:50, h:38},
                'decor19MC':{x:10, y:45, w:58, h:38},
                'decor100MC':{x:0, y:50, w:135, h:329},
                'decor69MC':{x:-234, y:-5, w:253, h:135},
                'decor68MC':{x:78, y:-6, w:188, h:135},
                'decor101MC':{x:1, y:10, w:178, h:78},
                'decor59MC':{x:0, y:0, w:23, h:63}
            };
            let mapLookingLeft:object = {
                'decor99MC':false,
                'decor98MC':false,
                'decor96MC':false,
                'decor97MC':false,
                'decor108MC':true,
                'decor105MC':true,
                'decor106MC':true,
                'decor102MC':true,
                'decor103MC':true
            };
            let decor;
            if (bodySize.hasOwnProperty(libId)) {
                decor = this.scene.physics.add.sprite(0, 0, 'decor-atlas', libId + '0000');
                decor.setCollideWorldBounds(false);
                decor.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
                decor.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
                if (bodySize[libId].hasOwnProperty('yFlipped')) {
                    decor.body.offset['-y-'] = bodySize[libId]['y'];
                    decor.body.offset['-yFlipped-'] = bodySize[libId]['yFlipped'];
                } else {
                    decor.setImmovable(true);
                }
                decor.body["setAllowGravity"](false);
            } else {
                let frame:string = libId + '0000';
                decor = this.scene.add.sprite(0, 0, 'decor-atlas', frame);
                if (!(decor as Phaser.GameObjects.Sprite).texture.frames.hasOwnProperty(frame)) {
                    decor.visible = false;
                }
            }
            if (mapLookingLeft.hasOwnProperty(libId)) {
                decor['lookingLeft'] = mapLookingLeft[libId];
            }
            if (mapOrigins[libId]) {
                decor.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
            } else {
                decor.setOrigin(0.5, 0.5);
            }
            if (animations[libId]) {
                let anim:string = libId + "_" + "playingAnimName";
                decor["playingAnimName"] = anim;
                if (!this.scene.anims.exists(anim)) {
                    this.scene.anims.create({
                        key: anim,
                        frames: this.scene.anims.generateFrameNames(decor.texture.key, {
                            start: animations[libId]['start'], end: animations[libId]['end'], zeroPad: 4,
                            prefix: libId, suffix: ''
                        }),
                        frameRate: 60,
                        repeat: animations[libId]['autoplay'] ? -1 : 0
                    });
                }
                if (animations[libId]['autoplay']) {
                    decor.play(decor["playingAnimName"]);
                }
            }

            return decor;
        }
        private createEnemySprite(libId:string):Phaser.GameObjects.Sprite {
            let enemy4MC_Origin = {'x':0.5, 'y':0.5};
            let mapOrigins:object = {
                'enemy4MC_kid1':enemy4MC_Origin,
                'enemy4MC_kid2':enemy4MC_Origin,
                'enemy4MC_kid3':enemy4MC_Origin,
                'enemy3MC':{'x':5/26, 'y':26/57},
                'enemy5MC':{'x':1/138, 'y':38/241},
                'hazard6MC':{'x':-14/34, 'y':0},
                'hazard4MC':{'x':-16/34, 'y':25/25},
                'hazard5MC':{'x':-6/52, 'y':64/61},
                'hazard3MC':{'x':-6/52, 'y':61/61}
            };
            let enemy4MC_animations = {
                'idle':{'start': 0, 'end':12, 'repeat':0},
                'bounce':{'start': 13, 'end':30, 'repeat':0},
                'attack':{'start': 13, 'end':30, 'repeat':0},
                'bounceSide':{'start': 31, 'end':51, 'repeat':0},
                'hit':{'start': 31, 'end':51, 'repeat':0},
                'die':{'start': 52, 'end':79, 'repeat':0}
            };
            let animations:object = {
                'enemy4MC_kid1':enemy4MC_animations,
                'enemy4MC_kid2':enemy4MC_animations,
                'enemy4MC_kid3':enemy4MC_animations,
                'enemy3MC': {
                    'idle':{'start': 0, 'end':19, 'repeat':0},
                    'attack':{'start': 91, 'end':146, 'repeat':0},
                    'die':{'start': 148, 'end':169, 'repeat':0},
                    'hit':{'start': 23, 'end':23, 'repeat':0},
                },
                'enemy5MC': {
                    'idle':{'start': 0, 'end':8, 'repeat':0},
                    'appear':{'start': 9, 'end':69, 'repeat':0},
                    'appeared':{'start': 70, 'end':80, 'repeat':0},
                    'attack':{'start': 81, 'end':183, 'repeat':0},
                    'hit':{'start': 225, 'end':230, 'repeat':0},
                    'disappear':{'start': 184, 'end':266, 'repeat':0},
                    'die':{'start': 267, 'end':324/*317*/, 'repeat':0},
                    'dead':{'start': 267, 'end':324, 'repeat':0}
                }
            };
            let enemy4MC_bodySize = {x:24, y:24, w:14, h:14};
            let bodySize:object = {
                'enemy4MC_kid1':enemy4MC_bodySize,
                'enemy4MC_kid2':enemy4MC_bodySize,
                'enemy4MC_kid3':enemy4MC_bodySize,
                'enemy3MC':{x:15, y:45, yFlipped:3, w:26, h:22},
                'enemy5MC':{x:43, y:70, w:60, h:55},
                'hazard6MC':{x:10, y:5, w:24, h:15},
                'hazard4MC':{x:12, y:4, w:12, h:15},
                'hazard5MC':{x:4, y:21, w:46, h:33},
                'hazard3MC':{x:12, y:4, w:27, h:23},
            };

            let enemy:Phaser.Physics.Arcade.Sprite = this.scene.physics.add.sprite(0, 0, 'enemies-atlas', libId + '0000');
            enemy.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
            enemy.setCollideWorldBounds(false);
            enemy.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
            enemy.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
            if (bodySize[libId].hasOwnProperty('yFlipped')) {
                enemy.body.offset['-y-'] = bodySize[libId]['y'];
                enemy.body.offset['-yFlipped-'] = bodySize[libId]['yFlipped'];
            } else {
                enemy.setImmovable(true);
            }
            enemy.body["setAllowGravity"](false);

            if (animations[libId]) {
                for (let k in animations[libId]) {
                    let anim:string = libId + "_" + k;
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(enemy.texture.key, {
                                start: animations[libId][k]['start'], end: animations[libId][k]['end'], zeroPad: 4,
                                prefix: libId, suffix: ''
                            }),
                            frameRate: 60,
                            repeat: animations[libId][k]['repeat']
                        });
                    }
                }
            }

            return enemy;
        }

        private createOtherSprite(libId:string):Phaser.GameObjects.Sprite {
            let mapOrigins:object = {
                'bblock1MC':{'x':0.5, 'y':1}
            };

            if (!mapOrigins.hasOwnProperty(libId)) return null;

            let bodySize:object = {
                'bblock1MC':{x:0, y:32/2-4, w:32, h:32}
            };
            let animations:object = {
                'bblock1MC':{
                    'masked':{'start': 7, 'end':7, 'repeat':0},
                    'wobble':{'start': 55, 'end':72, 'repeat':0},
                    'question-wobble':{'start': 74, 'end':91, 'repeat':0},
                    'break':{'start': 93, 'end':98, 'repeat':0},
                    'hidden':{'start': 100, 'end':107, 'repeat':0},
                    'makeSolid':{'start': 108, 'end':124, 'repeat':0},
                    'maskToSolid':{'start': 125, 'end':141, 'repeat':0},
                    'hiddenToSolid':{'start': 143, 'end':158, 'repeat':0},
                    'solid':{'start': 159, 'end':159, 'repeat':0},
                    'question':{'start': 167, 'end':174, 'repeat':0}
                }
            };

            let sprite:Phaser.Physics.Arcade.Sprite = this.scene.physics.add.sprite(0, 0, 'objects-atlas', libId + '0000');
            sprite.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
            sprite.setCollideWorldBounds(false);
            sprite.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
            sprite.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
            sprite.setImmovable(true);
            sprite.body["setAllowGravity"](false);

            for (let k in animations[libId]) {
                let anim:string = libId + "_" + k;
                if (!this.scene.anims.exists(anim)) {
                    this.scene.anims.create({
                        key: anim,
                        frames: this.scene.anims.generateFrameNames(sprite.texture.key, {
                            start: animations[libId][k]['start'], end: animations[libId][k]['end'], zeroPad: 4,
                            prefix: libId, suffix: ''
                        }),
                        frameRate: 60,
                        repeat: animations[libId][k]['repeat']
                    });
                }
            }

            return sprite;
        }

        public createSprite(spriteInfo
                                    /*
                                    spriteInfo[0] = sprite id
                                    spriteInfo[1] = x
                                    spriteInfo[2] = y
                                    spriteInfo[3] = libId
                                    spriteInfo[4] = options
                                    */
                            ):Phaser.GameObjects.Sprite | Phaser.GameObjects.Container {
            let libId:string = spriteInfo[3];

            if (libId == "enemy4MC") libId = "enemy4MC" + "_kid" + (Math.ceil(Math.random()*3));

            let sprite_mc:Phaser.GameObjects.Sprite | Phaser.GameObjects.Container = this.createConstructedObject(libId);
            if (!sprite_mc) {
                if (spriteInfo[3].indexOf("decor") == 0) {
                    sprite_mc = this.createDecorSprite(libId);
                } else if (spriteInfo[3].indexOf("enemy") == 0 || spriteInfo[3].indexOf("hazard") == 0) {
                    sprite_mc = this.createEnemySprite(libId);
                } else {
                    sprite_mc = this.createOtherSprite(libId);
                    if (!sprite_mc) {
                        sprite_mc = this.scene.add.sprite(0, 0, 'objects-atlas', libId + '0000')
                    }
                }
            }
            sprite_mc.setPosition(Number(spriteInfo[1]), Number(spriteInfo[2]));

            sprite_mc["libId"] = libId;

            let spriteId = sprite_mc["spriteId"] = spriteInfo[0];

            // extract options
            let options:string[] = spriteInfo[4].split('_');

            let spriteType:string = sprite_mc["spriteType"] = options[0];

            if (spriteType == 'E') {
                // enemy
                // define enemy hits required
                sprite_mc["hitsToKill"] = Number(options[1]);
                // pixel range
                sprite_mc["enemyType"] = options[3];
                //sprite_mc.dx = sprite_mc.xSpeed;
                sprite_mc["dy"] = 0;
                sprite_mc["dead"] = false;
            } else if (spriteType == 'H') {
                // hazard
                // define hazard strength
                sprite_mc["strength"] = options[1];
            } else if (spriteType=='C') {
                // chick / collectable
                // orientate?
                if (Math.random()>0.5) sprite_mc.scaleX = -1;
                sprite_mc["points"] = Number(options[1]);
                // flap at random:
                // sprite_mc.gotoAndStop(Math.ceil(Math.random()*15));
            } else if (spriteType=='D') {
                // decor
                sprite_mc["decorType"] = options[1];
                sprite_mc["speech"] = options[2];
                if (sprite_mc["decorType"]=='protestor' && sprite_mc["speech"]) {
                    sprite_mc["speaking"] = false;
                    sprite_mc["dy"] = 0;
                } else if ((sprite_mc["decorType"]=='pipeDown' || sprite_mc["decorType"]=='pipeSide' || sprite_mc["decorType"]=='pipeUp') && sprite_mc["speech"]) {
                    // rename correctly:
                    sprite_mc["pipeRoute"] = sprite_mc["speech"];
                } else if (sprite_mc["decorType"]=='bounce' || sprite_mc["decorType"]=='uberBounce') {
                } else if (sprite_mc["decorType"] && sprite_mc["decorType"].substr(0,3)=='fan') {
                    if (sprite_mc["decorType"]=='fanUp') {
                        sprite_mc["fanDir"] = (sprite_mc["decorType"]=='fanUp') ? -1 : 1;
                    } else {
                        sprite_mc["fanDir"] = (sprite_mc["decorType"]=='fanLeft') ? -1 : 1;
                    }
                } else if (sprite_mc["decorType"]=='recovery') {
                    // recovery point
                    sprite_mc['-active-'] = false;
                } else if (sprite_mc["decorType"]=='switch') {
                    // flip switch
                    sprite_mc["switchType"] = options[3];
                }
                if (sprite_mc["decorType"]=='above') {
                    // send to front
                    // water object
                    if (sprite_mc["hitSpace_mc"]) {
                    }
                }
            } else if (spriteType == 'B') {
                // B (Blocks): [hitsToDestroy]-[playLabel]-[points/value]
                sprite_mc["hitsLeft"] = Number(options[1]);
                sprite_mc["playLabel"] = options[2];
                sprite_mc["points"] = Number(options[3]);
                sprite_mc["displayType"] = options[4];

                // value block?
                if (sprite_mc["playLabel"]) {
                    if (!sprite_mc["displayType"]) sprite_mc["displayType"] = 'question';
                    this.gotoAndPlay(sprite_mc as Phaser.GameObjects.Sprite, sprite_mc["displayType"]);
                }
            }

            return sprite_mc;
        }

        public createConstructedObject(libId:string):Phaser.GameObjects.Sprite | Phaser.GameObjects.Container {
            let object:Phaser.GameObjects.Sprite | Phaser.GameObjects.Container = null;
            if (libId == "bossMC") {
                object = new nscs.character.Boss(this.scene);
            } else if (libId == "flagPoleMC") {
                object = this.scene.add.container(0, 0);
                let flagPoleMC = this.scene.physics.add.sprite(0, 0, 'objects-atlas', 'flagPoleMC0000');
                flagPoleMC.setOrigin(0.5, 1);
                (flagPoleMC as Phaser.Physics.Arcade.Sprite).setCollideWorldBounds(false);
                (flagPoleMC as Phaser.Physics.Arcade.Sprite).body.setSize(9, 181);
                (flagPoleMC as Phaser.Physics.Arcade.Sprite).setImmovable(true);
                flagPoleMC.body["setAllowGravity"](false);
                object.add(flagPoleMC);
                object["flagPoleMC"] = flagPoleMC;

                let flag_kfc_MC = new Phaser.GameObjects.Image(this.scene,0, -185, 'objects-atlas','flag_kfc_MC0000');
                flag_kfc_MC.setOrigin(1, 0);
                (object as Phaser.GameObjects.Container).add(flag_kfc_MC);
                object["flag_kfc_MC"] = flag_kfc_MC;
            } else if (libId == "tinyChickMC") {
                object = this.scene.physics.add.sprite(0, 0, 'objects-atlas');
                object.setOrigin(12/24, 25/24);
                (object as Phaser.Physics.Arcade.Sprite).setCollideWorldBounds(false);
                (object as Phaser.Physics.Arcade.Sprite).body.setSize(24, 24);
                (object as Phaser.Physics.Arcade.Sprite).setImmovable(true);
                object.body["setAllowGravity"](false);

                let chick_mc_anim:string = 'tinyChickMC-anim';
                if (!this.scene.anims.exists(chick_mc_anim)) {
                    this.scene.anims.create({
                        key: chick_mc_anim,
                        frames: this.scene.anims.generateFrameNames('objects-atlas', {
                            start: 0, end: 15, zeroPad: 4,
                            prefix: 'tinyChickMC', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                object.play(chick_mc_anim);
            }
            return object;
        }

        public playAnimation(object:Phaser.GameObjects.Sprite | Phaser.GameObjects.Container, animName:string = null):void {
            if (object["libId"] == "flagPoleMC") {
                let fn = (d)=>{
                    nscs.util.Functions.delayedCall(d, ()=>{
                        let flag_peta_MC = new Phaser.GameObjects.Image(this.scene,0, 0, 'objects-atlas','flag_peta_MC0000');
                        flag_peta_MC.setOrigin(0, 0);
                        flag_peta_MC.scaleX = 1;
                        flag_peta_MC.scaleY = 0;
                        this.scene.tweens.add({
                            targets: flag_peta_MC,
                            duration: 500,
                            y:-185,
                            scaleY:1,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                        (object as Phaser.GameObjects.Container).add(flag_peta_MC);
                    });
                };

                if (animName == "normal-flag-reached") {
                    this.scene.tweens.add({
                        targets: object["flagPoleMC"],
                        duration: 500,
                        alpha:1,
                        ease:Phaser.Math.Easing.Back.Out
                    });

                    this.scene.tweens.add({
                        targets: object["flag_kfc_MC"],
                        duration: 500,
                        y:0,
                        scaleY:0,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: ()=>{if(object["flag_kfc_MC"].parentContainer)object["flag_kfc_MC"].parentContainer.remove(object["flag_kfc_MC"]);}
                    });

                    fn(500);
                } else if (animName == "boss-flag-reached") {
                    object["flagPoleMC"].alpha = 0;
                    this.scene.tweens.add({
                        targets: object["flagPoleMC"],
                        duration: 500,
                        alpha:1,
                        ease:Phaser.Math.Easing.Back.Out
                    });

                    let flag_kfc_MC = object["flag_kfc_MC"].setPosition(0, -185);
                    this.scene.tweens.add({
                        targets: flag_kfc_MC,
                        duration: 500,
                        y:0,
                        scaleY:0,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: ()=>{if(flag_kfc_MC.parentContainer)flag_kfc_MC.parentContainer.remove(flag_kfc_MC);}
                    });

                    fn(1000);
                } else if (animName == "boss-flag-appear") {
                    object.y = object.y - 250;
                    object.setScale(1, 0.5);
                    object.alpha = 0;
                    this.scene.tweens.add({
                        targets: object,
                        duration: 500,
                        scaleY:1,
                        y:object.y + 250,
                        alpha:1,
                        ease:Phaser.Math.Easing.Back.Out
                    });

                    let flag_kfc_MC = object["flag_kfc_MC"].setPosition(0, -50);
                    flag_kfc_MC.scaleY = 0;
                    this.scene.tweens.add({
                        targets: flag_kfc_MC,
                        duration: 500,
                        y:-185,
                        scaleY:1,
                        ease: Phaser.Math.Easing.Sine.Out
                    });
                    (object as Phaser.GameObjects.Container).add(flag_kfc_MC);
                }
            } else if (object["playingAnimName"]) {
                (object as Phaser.GameObjects.Sprite).play(object["playingAnimName"]);
            }
        }

        public gotoAndPlay(sprite:Phaser.GameObjects.Sprite, label:string):void {
            let animName:string = sprite["libId"] + "_" + label;
            sprite['_animationComplete_'] = false;
            sprite['_animationToComplete_'] = animName;
            if (!sprite["_animationComplete_listener_"]) {
                sprite["_animationComplete_listener_"] = true;
                sprite.on('animationcomplete', ()=>{
                    if (sprite.anims.getCurrentKey() == sprite['_animationToComplete_']) {
                        sprite['_animationComplete_'] = true;
                    }
                });
            }

            sprite.anims.stop();
            sprite.play(animName);
        }

        public isAnimationComplete(sprite):boolean {
            return !sprite.hasOwnProperty('_animationComplete_') || sprite['_animationComplete_'];
        }

        public createRonaldSprite():Phaser.GameObjects.Sprite {
            let ronald_mc = this.scene.add.sprite(335, 115, 'ui-atlas', 'ronald_mc0000');
            let ronald_mc_anims:object = {
                'appear': {start: 0, end: 37},
                'disappear': {start: 38, end: 70},
                'disappeared': {start: 71, end: 83},
                'hit': {start: 84, end: 255},
                'idle': {start: 256, end: 798},
                'laugh': {start: 799, end: 884},
                'midLaugh': {start: 826, end: 884}
            };
            for (let an in ronald_mc_anims) {
                if (!this.scene.anims.exists(an)) {
                    this.scene.anims.create({
                        key: an,
                        frames: this.scene.anims.generateFrameNames('ui-atlas', {
                            start: ronald_mc_anims[an]['start'], end: ronald_mc_anims[an]['end'], zeroPad: 4,
                            prefix: 'ronald_mc', suffix: ''
                        }),
                        frameRate: 60
                    });
                }
            }
            return ronald_mc;
        }
    }
}